import type { FacilityConfig } from './types.js'

/**
 * The configuration a facility starts with: applied by the operator's New
 * facility form as part of creating one, and offered by the dashboard's
 * "not configured" screen for a facility registered any other way. A
 * starting point, not a decision - the operator adjusts it from the
 * Configuration page.
 */
export const DEFAULT_FACILITY_CONFIG: Omit<FacilityConfig, 'facilityId'> = {
  scoreWeights: {
    callOutRate: 30,
    onTimeArrival: 20,
    chartingCompletion: 25,
    shiftCompletion: 20,
    noShowRate: 5,
  },
  tierThresholds: {
    goldMinScore: 80,
    silverMinScore: 60,
    bronzeMinScore: 40,
    tiebreaker: 'seniority',
  },
  bidWindowTiming: {
    scoringPeriodCloses: 'Last day of month',
    goldWindowOpensAt: '1st of month · 6:00 AM',
    goldWindowDurationHours: null,
    silverWindowOpensAt: null,
    bronzeWindowOpensAt: null,
    probationaryAssignment: 'Scheduler assigned',
  },
  clinicalBridge: {
    enabled: true,
    otPermitted: true,
    responseWindowMinutes: 20,
    scoreBoostPerShift: 5,
    payPremiumEnabled: true,
    payPremiumAmount: null,
    unfilledEscalationPath: ['internal', 'agency'],
    scoreRecalcFrequency: 'weekly',
    arrivalWindowMinutes: 60,
  },
  prioritizationEnabled: true,
}
